import { c as _c } from "react/compiler-runtime";
import { Button, Divider } from "@loanlight-engineering/shared-ui/primitives";
import { LoanLightTopBarWrapper } from "@/components/legacy-wrappers/LoanLightTopBarWrapper";
import { closeInteraction } from "@/services/encompass.service";
import { getSvg } from "@/utils/getSvgs";
import { useEllimae } from "@/store/useEllimae";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
export const AuditError = () => {
  const $ = _c(10);
  const ellimaeState = useEllimae(_temp);
  const errorMessage = ellimaeState.originResponse?.auditDetail?.errorMessage ?? "An unexpected error occurred during the audit.";
  const handleClose = _temp4;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LoanLightTopBarWrapper className="sticky top-0"><div slot="right"><Button color="dark" onClick={handleClose} className="min-h-8 px-3 py-[5.5px] items-center"><span dangerouslySetInnerHTML={{
            __html: getSvg("xSvg")
          }} /></Button></div></LoanLightTopBarWrapper>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ExclamationTriangleIcon className="h-12 w-12 text-red-500" />;
    t2 = <h2 className="m-0 text-center text-[32px] font-medium text-zinc-900 tracking-[-0.96px] leading-none">Audit Failed</h2>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== errorMessage) {
    t3 = <p className="m-0 text-center text-base font-normal text-brand-950 leading-normal tracking-[-0.32px]">{errorMessage}</p>;
    $[3] = errorMessage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Divider />;
    t5 = <p className="m-0 pt-4 text-center text-base font-normal text-brand-950 leading-normal tracking-[-0.32px]">Please close this window and re-launch LoanLight from Encompass to start a new audit.</p>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="w-full pt-4"><Button color="dark" className="w-full" onClick={handleClose}>Close</Button></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3) {
    t7 = <div className="min-h-screen flex flex-col bg-brand-900">{t0}<div className="flex flex-1 flex-col items-center pt-[4vh]"><div className="w-148 rounded-2xl bg-white shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_10px_10px_-5px_rgba(0,0,0,0.04)] flex flex-col items-center"><div className="flex flex-col items-center gap-4 p-8 w-full">{t1}{t2}{t3}{t4}{t5}{t6}</div></div></div></div>;
    $[8] = t3;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
function _temp(state) {
  return state;
}
async function _temp2() {
  await closeInteraction();
}
function _temp3(e) {
  console.error(e);
}
function _temp4() {
  _temp2().catch(_temp3);
}